module.exports = __webpack_public_path__ + "static/media/flask-3.746ef1b0.svg";